// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('CadFormatVO')
export class CadFormatVO {
  @JsonProperty('name', 'String')
  public name: string = undefined;

  @JsonProperty('format', 'String')
  public format: string = undefined;

  @JsonProperty('version', 'String')
  public version: string = undefined;
}
